import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
// import Home from '@/views/Home.vue';
// import About from '@/views/About.vue';
// import Manage from '@/views/Manage.vue';
// import Song from '@/views/Song.vue';

const Home = () => import('@/views/Home.vue');
const About = () =>
  import(/* webpackChunkName: "groupedChunk" */ '@/views/About.vue');
const Manage = () =>
  import(/* webpackChunkName: "groupedChunk" */ '@/views/Manage.vue');
const Song = () => import('@/views/Song.vue');

const routes = [
  {
    name: 'home',
    path: '/',
    component: Home,
  },
  {
    name: 'about',
    meta: {
      requiresAuth: true,
    },
    path: '/about',
    component: About,
  },
  {
    name: 'manage',
    // alias: '/manage'
    path: '/manage-music',
    component: Manage,
    // beforeEnter: (to, from, next) => {
    //   console.log('managed guard');
    // }
  },
  {
    path: '/manage',
    redirect: { name: 'manage' }, // For redirecting to another route
  },
  {
    name: 'song',
    path: '/song/:id',
    component: Song,
  },
  {
    path: '/:catchAll(.*)*', // if the route not exist redirect to home (can also be used to load 404 page)
    redirect: { name: 'home' },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkExactActiveClass: 'text-yellow-500',
});

// Global Guard Middleware to protect routes
router.beforeEach((to, from, next) => {
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    next();
    return;
  }

  if (store.state.auth.userLoggedIn) {
    next();
  } else {
    next({ name: 'home' });
  }
});

export default router;
